import React, { useState, useEffect } from "react";
import axios from 'axios';
import { addThousandPoint,ChangeDateString,PassedMonths,ChangeMobileFormat,isObjEmpty,GetAdminPaymentStatus,GetAdminAttendanceStatusString } from "../common/Common";

import sampleImage from "../../img/sample01.png";

const PopupChildrenStudy = ({varOpenChildrenStudy,varChildrenInfo,CloseChildrenStudy}) => {
  //수강정보
  const [varClassInfo,setClassInfo] = useState({});
  const [varChildrenData,setChildrenData] = useState({});
  const [varPaymentData,setPaymentData] = useState({});
  const [varStudyList,setStudyList] = useState([]);
  const [varChildrenPhoto,setChildrenPhoto] = useState(sampleImage);

  //수강 정보 호출
  const GetChildrenStudyInformation = async() => {
    const sendData = {cl_idx:varChildrenInfo.cl_idx,ch_idx:varChildrenInfo.ch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_children_study_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setChildrenData(datas.children);

        if(datas.payments?.length > 0) setPaymentData(datas.payments[0]);
        else setPaymentData({});

        const classInfoList = datas.classInfo;
        //let classClassName = "";
        if(classInfoList.length > 0) {
          //classClassName = classInfoList[0].cl_name;
          setClassInfo(classInfoList[0]);
          if(classInfoList[0].ch_image === 1) {
            setChildrenPhoto(`${process.env.REACT_APP_HOST}/member/${classInfoList[0].ch_file}`);
          }
        } 

        let studys = datas.studys;
        let studyList = [];
        for(var i=0; i < studys.length; i++) {
          let sline = studys[i].cs_index+"차 수업 : "+ GetAdminAttendanceStatusString(studys[i]);
          studyList.push(sline);
        }
        setStudyList(studyList);
      } else {
        setClassInfo([]);
        setChildrenData([]);
        setPaymentData({});
        setChildrenPhoto(sampleImage);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    if(!isObjEmpty(varChildrenInfo)) GetChildrenStudyInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varChildrenInfo]);

  return (
    <div className={varOpenChildrenStudy?"layer__pop open":"layer__pop"}>
      <div className="layer__pop__confirm" style={{maxWidth:"500px",paddingBottom:"20px"}}>
        <div className="layer__bottom__head mb15">
          <div className="layer__pop__title" style={{paddingTop:"20px"}}>원생별 수강 현황</div>
          <div className="layer__pop__close" onClick={()=>CloseChildrenStudy()}></div>
        </div>
        <div className="layer__pop__body">  
          <div className="body-title"> 
            <div className="children-info">
              {varChildrenData.ch_name} {PassedMonths(varChildrenData.ch_birthday)}개월({ChangeDateString(varChildrenData.ch_birthday)}) ({varChildrenData.ch_status===1?"재원":"퇴원"})
            </div>
            <div className="study-info">
              <img src={varChildrenPhoto} alt=""/>
              <div className="study-right-info">
                <div>{varClassInfo.sm_name}</div>
                <div>{ChangeDateString(varClassInfo.sm_sdate)+" ~ "+ChangeDateString(varClassInfo.sm_edate)}</div>
                <div>수업차수 {varClassInfo.max_cnt+varClassInfo.min_cnt}/{varClassInfo.tstudys}&nbsp;&nbsp; 출석 {varClassInfo.max_cnt}&nbsp;&nbsp; 결석 {varClassInfo.min_cnt}</div>
              </div>
            </div>
          </div>
          {isObjEmpty(varPaymentData)?
            <div className="body-payment">
              <div className="payment-title">
                <div>결제현황</div>
                <div className="payment-money">미결제</div>
              </div>
            </div>
          :
            <div className="body-payment">
              <div className="payment-title">
                <div>결제현황</div>
                <div className="payment-money">결제완료  {addThousandPoint(varPaymentData.ph_price)}원</div>
              </div>
              <div className="payment-body">
                <div>청구서구분 : {varClassInfo.cl_name}</div>
                <div>수업구분 : {varClassInfo.cl_mode===1?"정규":"보강"} 수업</div>
                <div>학부모 : {varPaymentData.mem_name} ({ChangeMobileFormat(varPaymentData.mem_mobile)})</div>
                <div>청구서 : {varPaymentData.ivc_id}</div>
                <div>결제상태 : {varPaymentData.ph_status===2?`결제완료 (${ChangeDateString(varPaymentData.ph_pdate)})`
                            : GetAdminPaymentStatus(varPaymentData.ph_status)}</div>
              </div>
            </div>
          }
          <div className="body-study-list">
            <div className="study-list-title">출결 현황</div>
            <div className="study-list">
              <ul>
                {varStudyList.map((lines,i)=>(
                  <li key={'lines_'+i}>{lines}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PopupChildrenStudy;